'use strict';

const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const GroupBasedDataService=require('../../../dist-es6/client/services/groupBasedDataService');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');let

FatigueTrendsDataService=class FatigueTrendsDataService extends GroupBasedDataService{
static get $inject(){
return['$timeout','statisticalDisplayDataService','timeZoneService','groupTreeService'];
}

constructor($timeout,statisticalDisplayDataService,timeZoneService,groupTreeService){
super($timeout,groupTreeService);
this._statisticalDisplayDataService=statisticalDisplayDataService;
this._localTimeZone=timeZoneService.localTimeZone;

this._displayInterval=void 0;
}

get displayInterval(){
return this._displayInterval;
}

set displayInterval(displayInterval){
this._displayInterval=displayInterval;
}

_clearPersistentData(){
super._clearPersistentData();
this._displayInterval=void 0;
}

async _update(cancellationToken){
const statisticsRequest={
calendarRange:CalendarRange.fromTimeInterval(this._displayInterval,this._localTimeZone),
requestedOrgStats:[
'averageFatigueOnDuty',
'maxFatigueOnDuty'],

requestedGroupStats:[
'averageFatigueOnDuty',
'maxFatigueOnDuty'],

requestedPersonalStats:[
'fatigueDistribution',
'dutyHours',
'maxFatigueOnDuty',
'averageFatigueOnDuty']};



if(this._fatigueMeterType===FatigueMeterType.Workforce){
_.pushMany(statisticsRequest.requestedPersonalStats,['numDuties']);
}

const fleetInsightData=await this._statisticalDisplayDataService.fetchFatigueTrendsDataFor(statisticsRequest);

if(cancellationToken.cancelled){
return;
}

this._groupTreeService.updateOrgLevelGroupVisibilitySettings({
hideAllGroupsByDefault:fleetInsightData.hideAllGroupsByDefault});


this.groupTree=fleetInsightData.groupTree;
}};


module.exports=FatigueTrendsDataService;
//# sourceMappingURL=fatigueTrendsDataService.js.map
